'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _helpers = require('../../common/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import '../css/adminlte.css'

var VisitorInfo = function (_Component) {
    _inherits(VisitorInfo, _Component);

    function VisitorInfo(props) {
        _classCallCheck(this, VisitorInfo);

        var _this = _possibleConstructorReturn(this, (VisitorInfo.__proto__ || Object.getPrototypeOf(VisitorInfo)).call(this, props));

        _this.getCustomerInfo = function () {
            var body = {
                "profile_id": _this.props.user_id,
                "profile_type": "guest"
            };

            var customerInfoUrl = window.sfChat.baseApiUrl + "/v1/customer/info";

            var headers = (0, _helpers.getAuthHeader)();

            fetch(customerInfoUrl, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body)
            }).then(function (response) {
                return response.json();
            }).then(function (res) {
                if (res.status === "success") {
                    _this.updateCustomerState(res.data);
                } else {
                    console.log("Fetching Customer info failed");
                    _this.updateCustomerState(res.data);
                }
            }).catch(function (err) {
                console.log(err);
            });
        };

        _this.updateCustomerState = function (data) {
            console.log(data);

            _this.setState({
                customerName: data.customer_name ? data.customer_name : "Guest",
                customerPhone: data.customer_phone ? data.customer_phone : "NA",
                customerEmail: data.customer_email ? data.customer_email : "NA",
                customerType: data.customer_type ? data.customer_type : "NA",
                customerMode: data.customer_mode ? data.customer_mode : "NA",
                customerLocation: data.customer_location ? data.customer_location : "NA",
                customerJoinedAt: data.customer_joined_at ? (0, _moment2.default)(data.customer_joined_at).format("LLL") : "-",
                customerIPAddress: data.customer_ip ? data.customer_ip : "NA",
                helpRequest: data.help_request ? data.help_request : "NA",
                isFetchingData: true
            });
        };

        _this.state = {
            customerName: 'Guest',
            customerPhone: '',
            customerEmail: '',
            customerType: '',
            customerMode: '',
            customerLocation: '',
            customerJoinedAt: '',
            customerIPAddress: '',
            helpRequest: '',
            isFetchingData: false
        };
        return _this;
    }

    _createClass(VisitorInfo, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (!this.state.isFetchingData) {
                this.getCustomerInfo();
            }
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { className: 'box-primary', style: { backgroundColor: "#b0b5ad", color: "#000000", display: "flex", flexFlow: "column" } },
                _react2.default.createElement(
                    'div',
                    { className: 'box-profile', style: { paddingRight: "3px", paddingLeft: "3px" } },
                    _react2.default.createElement('img', { className: 'profile-user-img img-responsive img-circle', src: 'https://www.imran.com/xyper_images/icon-user-default.png', alt: 'user pic' }),
                    _react2.default.createElement(
                        'h3',
                        { className: 'profile-username text-center' },
                        this.state.customerName
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'list-group list-group-unbordered' },
                        _react2.default.createElement(
                            'li',
                            { className: 'list-group-item', style: { paddingLeft: "10px", paddingRight: "10px" } },
                            _react2.default.createElement(
                                'b',
                                null,
                                'Phone '
                            ),
                            ' ',
                            _react2.default.createElement(
                                'a',
                                { className: 'pull-right' },
                                this.state.customerPhone
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'list-group-item', style: { paddingLeft: "10px", paddingRight: "10px" } },
                            _react2.default.createElement(
                                'b',
                                null,
                                'Email '
                            ),
                            ' ',
                            _react2.default.createElement(
                                'a',
                                { className: 'pull-right' },
                                this.state.customerEmail
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'list-group-item', style: { paddingLeft: "10px", paddingRight: "10px" } },
                            _react2.default.createElement(
                                'b',
                                null,
                                'Mode '
                            ),
                            ' ',
                            _react2.default.createElement(
                                'a',
                                { className: 'pull-right' },
                                this.state.customerMode
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'list-group-item', style: { paddingLeft: "10px", paddingRight: "10px" } },
                            _react2.default.createElement(
                                'b',
                                null,
                                'Location '
                            ),
                            ' ',
                            _react2.default.createElement(
                                'a',
                                { className: 'pull-right' },
                                this.state.customerLocation
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'list-group-item', style: { paddingLeft: "10px", paddingRight: "10px" } },
                            _react2.default.createElement(
                                'b',
                                null,
                                'IP '
                            ),
                            ' ',
                            _react2.default.createElement(
                                'a',
                                { className: 'pull-right' },
                                this.state.customerIPAddress
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'list-group-item', style: { paddingLeft: "10px", paddingRight: "10px" } },
                            _react2.default.createElement(
                                'b',
                                null,
                                'Meeting Id '
                            ),
                            ' ',
                            _react2.default.createElement(
                                'a',
                                { className: 'pull-right' },
                                this.props.meetingId
                            )
                        )
                    )
                )
            );
        }
    }]);

    return VisitorInfo;
}(_react.Component);

exports.default = VisitorInfo;


// WEBPACK FOOTER //
// ../chat/lib/components/visitor_info/visitor_info.js